const ACADEMIC_API_URL =
  process.env.REACT_APP_ACADEMIC_API_URL || 'https://o0vnudbmyc.execute-api.eu-central-1.amazonaws.com';

class AcademicExpirationNotificationService {
  private recordingInProgress = new Map<string, Promise<{ success: boolean; message: string }>>();

  async recordExpirationNotification(email: string, userNotifiedAt?: string): Promise<{ success: boolean; message: string }> {
    if (userNotifiedAt) {
      return {
        success: true,
        message: 'User already notified',
      };
    }

    if (this.recordingInProgress.has(email)) {
      return this.recordingInProgress.get(email)!;
    }

    const recordingPromise = this.performRecording(email);
    this.recordingInProgress.set(email, recordingPromise);

    try {
      const result = await recordingPromise;
      return result;
    } finally {
      this.recordingInProgress.delete(email);
    }
  }

  private async performRecording(email: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await fetch(`${ACADEMIC_API_URL}/record-expiration-notification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.warn('Failed to record expiration notification:', data.error);
        return {
          success: false,
          message: data.error || 'Failed to record notification',
        };
      }

      return {
        success: true,
        message: 'Notification recorded',
      };
    } catch (error) {
      console.warn('Error recording expiration notification:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }
}

const academicExpirationNotificationService = new AcademicExpirationNotificationService();
export default academicExpirationNotificationService;
